export enum UserActionsTypes {
  "LIST_USER" = "LIST_USER",
  "UPDATE_USER" = "UPDATE_USER",
  "DELETE_USER" = "DELETE_USER",
  "DELETE_MULTIPLE_USER" = "DELETE_MULTIPLE_USER",
  "GET_LOGGED_USER" = "GET_LOGGED_USER",
  "SEND_USER_MAIL" = "SEND_USER_MAIL",
  "CREATE_USER" = "CREATE_USER"
}

export enum UserMutationsTypes {
  "SET_LIST_USER" = "SET_LIST_USER",
  "UPDATE_USER" = "UPDATE_USER",
  "DELETE_USER" = "DELETE_USER",
  "DELETE_MULTIPLE_USER" = "DELETE_MULTIPLE_USER",
  "SET_LOGGED_USER" = "SET_LOGGED_USER",
  "CREATE_USER" = "CREATE_USER"
}

export enum UserGettersTypes {
  "USER_BY_ID" = "USER_BY_ID",
  "USER_ALL_ID" = "USER_ALL_ID",
  "LOGGED_USER" = "LOGGED_USER"
}
